jQuery(document).ready(function () {
    toggleFaq();
    initMap();
    initBlogSlider();
    initLoadVita();
    initOpenIframe();
    initImageSlider();
    initContactModal();
    initSingleRealEstateModal();
    initImmoGallery();
    initAdaptImmoModal();
    initBrowserCheck();
    initBurgerMenu();
});


function initBurgerMenu() {
    const burger = jQuery('.burger-menu');
    const container = jQuery('.mobile-menu');

    burger.on('click', function (e) {
        e.preventDefault();
        container.slideToggle('active');
        burger.toggleClass('active');
        jQuery('body').toggleClass('no-scroll');
    })
}

function initSingleRealEstateModal() {//
    const modal = jQuery('.real-estate-modal');
    const button = jQuery('#open-single-real-estate-contact');
    const close = jQuery('.close-real-estate-modal');
    let contactform = jQuery('.im-contact-form');

    if (contactform.children('div').length !== 7) modal.addClass('show');

    button.on('click', function () {
        modal.addClass('show');
    })

    close.on('click', function () {
        modal.removeClass('show');
    })
}

function initContactModal() {
    const button = jQuery('#kontakt-modal-button');
    const modal = jQuery('.contact-modal');
    const close = jQuery('.close-contact-modal');

    button.on('click', function () {
        modal.addClass('flex');
    })

    close.on('click', function () {
        modal.removeClass('flex');
    })
}

function toggleFaq() {
    $(".js-faq-title").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass("faq__active")) {
            $(".js-faq-content").slideUp(800);
            $(".js-faq-title").removeClass("faq__active");
            $('.js-faq-rotate').removeClass('faq__rotate');
        }
        $this.toggleClass("faq__active");
        $this.next().slideToggle();
        $('.js-faq-rotate', this).toggleClass('faq__rotate');
    });
}

function initMap() {

    const button = jQuery('#accept-dsgvo');
    const hideOnAccept = jQuery('.hide-on-accept');

    button.on('click', function () {
        hideOnAccept.css('display', 'none');
        jQuery('.map-widget').css('background-image', 'unset');
        let src = "https://maps.google.com/maps?q=Mensch%20und%20Immobilie%20GmbH%20Splieterstrasse%2074%2048231Warendorf&t=&z=13&ie=UTF8&iwloc=&output=embed";
        jQuery('#map-location').css({"display": "block", "width": "100%", "height": "400px"});
        document.getElementById('map-location').setAttribute('src', src);
    });
}

function initBlogSlider() {

    let container = jQuery('.blog-slider');

    if (container.length) {
        jQuery(container).slick({
            arrows: false,
            dots: false,
            infinite: true,
            speed: 300,
            autoplay: true,
            adaptiveHeight: false,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        adaptiveHeight: true
                    }
                },
            ]

        });
    }
}

function initImmoGallery() {
    let container = jQuery('#immo-gallery');

    if (container.length) {
        jQuery(container).slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        adaptiveHeight: true,
                        dots: false
                    }
                },
            ]

        });
    }
}

function initLoadVita() {
    const openModal = jQuery('.open-modal');
    const closeModal = jQuery('.close-button');
    const modal = jQuery('.vita-modal');

    closeModal.on('click', function () {
        modal.removeClass('show');
    });

    openModal.on('click', function () {
        const thisElement = jQuery(this);
        const closestModal = thisElement.closest('.team-item').next('.vita-modal').first();
        closestModal.addClass('show');
        console.log('yep');
    });
}

function initOpenIframe() {
    const iframe = jQuery('.iframe-wrapper');
    const budgetrechner = jQuery('.budgetrechner-wrapper');
    const konditionsrechner = jQuery('.konditionsrechner-wrapper');
    const openBudgetR = jQuery('#budgetrechner');
    const openKonditionsR = jQuery('#konditionsrechner');
    const close = jQuery('.close-iframe');

    close.on('click', function () {
        iframe.removeClass('flex');
    })

    openKonditionsR.on('click', function () {
        konditionsrechner.addClass('flex');
    })


    openBudgetR.on('click', function () {
        budgetrechner.addClass('flex');
    })
}

function initImageSlider() {
    let container = jQuery('.image-slider');

    if (container.length) {
        jQuery(container).slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            adaptiveHeight: false,
            slidesToShow: 1
        });
    }
}

function initAdaptImmoModal() {
    const firstName = jQuery('#IM_option_real_estate_prename');
    const lastName = jQuery('#IM_option_real_estate_name');
    const phone = jQuery('#IM_option_real_estate_phone');
    const mail = jQuery('#IM_option_real_estate_mail');
    const street = jQuery('#IM_option_real_estate_street');
    const streetNumber = jQuery('#IM_option_real_estate_street_number');
    const zipCode = jQuery('#IM_option_real_estate_plz');
    const city = jQuery('#IM_option_real_estate_city');
    const message = jQuery('#IM_option_real_estate_message');
    const dataPrivacy = jQuery('.im-checkbox');
    const button = jQuery('.im_submit');
    const errorHeadline = jQuery('.im-error p');
    const mAcceptance = jQuery('.message.acceptance');
    const mPrename = jQuery('.message.pre_name');
    const mName = jQuery('.message.name');
    const mMail = jQuery('.message.mail');
    const mPhone = jQuery('.message.phone');
    const mStreet = jQuery('.message.street');
    const mStreetNum = jQuery('.message.street_nr');
    const mZip = jQuery('.message.zip');
    const mCity = jQuery('.message.city');

    errorHeadline.html('Pflichtfelder müssen ausgefüllt werden');
    mAcceptance.html('Sie müssen unsere Datenschutzerklärung lesen und akzeptieren');
    mPrename.html('Bitte überprüfen Sie Ihren Vornamen');
    mName.html('Bitte überprüfen Sie Ihren Nachnamen');
    mMail.html('Bitte überprüfen Sie Ihre E-Mail-Adresse');
    mPhone.html('Bitte überprüfen Sie Ihre Telefonnummer');
    mStreet.html('Bitte überprüfen Sie Ihren Straßennamen');
    mStreet.html('Bitte überprüfen Sie Ihren Straßennamen');
    mStreetNum.html('Bitte überprüfen Sie Ihren Hausnummer');
    mZip.html('Bitte überprüfen Sie Ihren Postleitzahl');
    mCity.html('Bitte überprüfen Sie Ihren Wohnort');

    firstName.attr('placeholder', 'Vorname*');
    lastName.attr('placeholder', 'Name*');
    phone.attr('placeholder', 'Telefon*');
    mail.attr('placeholder', 'E-Mailadresse*');
    street.attr('placeholder', 'Straße*');
    streetNumber.attr('placeholder', 'Hausnummer*');
    zipCode.attr('placeholder', 'Postleitzahl*');
    city.attr('placeholder', 'Stadt*');
    message.attr('placeholder', 'Nachricht*');
    dataPrivacy.html('<label for="data-privacy-check"><input id="data-privacy-check" type="checkbox" name="data-privacy-check">  Die Hinweise zum <a href="https://meuim.de/datenschutzerklarung/">Datenschutz</a> habe ich gelesen und verstanden.</label>');
    button.attr('value', 'Anfrage Senden');
}


// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if (isIE()) {
        jQuery('.ie-check').show();
    }
}